import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import regeneratorRuntime from "/home/vsts/work/1/s/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Head from "next/head";
import React, { useEffect, useState } from "react";
import { NavigationComponent } from "@biocentury/components";
import { GraphCMS } from "@biocentury/core";
import { Footer } from "@components/Footer";
import Header from "@components/Header";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var PageContainer = function(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var getPage = function getPage() {
        return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee() {
            var page;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return GraphCMS.fetchPageMenu({
                            path: "home",
                            pageSize: undefined
                        });
                    case 2:
                        page = _ctx.sent.page;
                        setPage(page);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    };
    var ref = useState(), page = ref[0], setPage = ref[1];
    useEffect(function() {
        getPage();
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Head, {
                children: [
                    /*#__PURE__*/ _jsx("meta", {
                        content: "summary",
                        name: "twitter:card"
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        content: "initial-scale=1.0, width=device-width",
                        name: "viewport"
                    })
                ]
            }),
            page && /*#__PURE__*/ _jsx(NavigationComponent, {
                page: page,
                ad: process.env.NEXT_PUBLIC_LEADERBOARD_Z1
            }),
            /*#__PURE__*/ _jsx(Header, {}),
            /*#__PURE__*/ _jsx("div", {
                className: "min-h-1/2",
                children: /*#__PURE__*/ _jsx(Component, _object_spread({}, pageProps))
            }),
            /*#__PURE__*/ _jsx(Footer, {})
        ]
    });
};
export default PageContainer;
